<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <div class="clearfix">
            <h1 class="float-left display-3 mr-4">{{ $t('page.errors.404.code') }}</h1>
            <h4 class="pt-3">{{ $t('page.errors.404.title') }}</h4>
            <p class="text-muted">{{ $t('page.errors.404.description') }}</p>
          </div>
        </b-col>
      </b-row>
      <b-row class="justify-content-center">
        <b-col md="6">
          <b-link :to="{path: `/`}" class="btn btn-secondary btn-block" type="button">
             {{ $t('actions.backToDashboard') }}
          </b-link>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Page404',
    inheritAttrs: false,
    props: {
      errorMessage: {
        required: true
      }
    },
  }

</script>
